import {Route} from '@angular/router';
import {ConsumptionAgentsOverviewComponent} from 'src/app/monitoring/consumption-agents/consumption-agents-overview/consumption-agents-overview.component';
import {NotificationHistoryComponent} from 'src/app/monitoring/notification-history/notification-history.component';
import {CreateConsumptionAgentComponent} from 'src/app/monitoring/consumption-agents/create-consumption-agent/create-consumption-agent.component';
import {environment} from 'src/environments/environment';
import {BuildingServices} from '@brunata-angular/util';
import {VariableAlarmsOverviewComponent} from './variable-alarms-overview/variable-alarms-overview.component';
import {EventAlarmsPageComponent} from 'src/app/meter/event-alarms-page/event-alarms-page.component';
import {EventAlarmsOverviewComponent} from './event-alarms-overview/event-alarms-overview.component';
import {CreateEventAlarmComponent} from './event-alarms-overview/create-event-alarm/create-event-alarm.component';
import {unsavedChangesGuard} from '@brunata-angular/ui';
import {OtherAgentsComponent} from './other-agents/other-agents.component';
import {IframeComponent} from '@shared/iframe/iframe.component';
import {ConsumptionAgentResultComponent} from './consumption-agents/consumption-agent-result/consumption-agent-result.component';
import {EditConsumptionAgentComponent} from './consumption-agents/edit-consumption-agent/edit-consumption-agent.component';
import {EditEventAlarmComponent} from './event-alarms-overview/edit-event-alarm/edit-event-alarm.component';
import {VariableAlarmSettingsComponent} from './variable-alarms-overview/create-variable-alarm/variable-alarm-settings/variable-alarm-settings.component';

export const monitoringRoutes: Route[] = [
    {path: '', redirectTo: 'consumption-agents', pathMatch: 'full'},
    {
        path: 'consumption-agents',
        component: ConsumptionAgentsOverviewComponent,
        data: {
            key: 'monitoring_consumption_agents',
            module: 'ngonline',
        },
        children: [
            {
                path: 'create',
                component: CreateConsumptionAgentComponent,
                canDeactivate: [unsavedChangesGuard],
                data: {key: 'monitoring_create_consumption_agent', module: 'ngonline'},
            },
            {
                path: ':reportid/edit',
                canDeactivate: [unsavedChangesGuard],
                component: EditConsumptionAgentComponent,
                data: {key: 'monitoring_edit_consumption_agent', module: 'ngonline'},
            },
            {
                path: ':alarmid',
                component: ConsumptionAgentResultComponent,
                data: {key: 'consumption-agents_results', module: 'ngonline'},
            },
        ],
    },
    {
        path: 'other-agents-overview',
        component: OtherAgentsComponent,
        data: {
            key: 'monitoring_other_agents',
            module: 'ngonline',
        },
        children: [
            {
                path: 'humidity',
                component: IframeComponent,
                data: {
                    key: 'titles_humidityMonitorReport',
                    module: 'monitoringAlarms',
                    url: `${environment.webmonIframeUrl}/online-portal/com.brunata.online.ReportAgent/reportagent.html?reportTypeId=5&p_anlstamdataid={buildingbasicdataid}`,
                },
            },
            {
                path: 'missing-readings',
                component: IframeComponent,
                data: {
                    key: 'titles_missingReadings',
                    module: 'monitoringAlarms',
                    url: `${environment.webmonIframeUrl}/online-portal/com.brunata.online.ReportAgent/reportagent.html?reportTypeId=3&p_anlstamdataid={buildingbasicdataid}`,
                },
            },
        ],
    },
    {
        path: 'variable-alarms',
        component: VariableAlarmsOverviewComponent,
        data: {
            key: 'monitoring_Variable-alarms',
            module: 'ngonline',
            requireBuildingService: BuildingServices.EVENTS_AGENTS_AND_ALARMS,
        },
        children: [
            {
                path: 'create/:templateType',
                component: VariableAlarmSettingsComponent,
                canDeactivate: [unsavedChangesGuard],
                data: {
                    key: 'monitoring_create-variable-alarm',
                    module: 'ngonline',
                    requireBuildingService: BuildingServices.EVENTS_AGENTS_AND_ALARMS,
                },
            },
            {
                path: ':deviationNotificRuleId/edit',
                component: VariableAlarmSettingsComponent,
                canDeactivate: [unsavedChangesGuard],
                data: {
                    key: 'monitoring_edit-variable-alarm',
                    module: 'ngonline',
                    requireBuildingService: BuildingServices.EVENTS_AGENTS_AND_ALARMS,
                },
            },
        ],
    },
    {
        path: 'event-alarms',
        component: EventAlarmsOverviewComponent,
        data: {
            key: 'event-alarms_event_alarms',
            module: 'ngonline',
            requireBuildingService: BuildingServices.EVENTS_AGENTS_AND_ALARMS,
        },
        children: [
            {
                path: 'create',
                redirectTo: '',
            },
            {
                path: 'create/:eventtypeid',
                component: CreateEventAlarmComponent,
                canDeactivate: [unsavedChangesGuard],
                data: {
                    key: 'event-alarms_create-event-alarm',
                    module: 'ngonline',
                    requireBuildingService: BuildingServices.EVENTS_AGENTS_AND_ALARMS,
                },
            },
            {
                path: ':id/edit',
                component: EditEventAlarmComponent,
                canDeactivate: [unsavedChangesGuard],
                data: {
                    key: 'event-alarms_edit-event-alarm',
                    module: 'ngonline',
                    requireBuildingService: BuildingServices.EVENTS_AGENTS_AND_ALARMS,
                },
            },
        ],
    },
    {
        path: 'notification-history',
        component: NotificationHistoryComponent,
        data: {key: 'monitoring_notification_history', module: 'ngonline'},
    },
    {
        path: 'latest-events',
        component: EventAlarmsPageComponent,
        data: {
            key: 'utilities_latest_event',
            module: 'ngonline',
            requireBuildingService: BuildingServices.EVENTS_AGENTS_AND_ALARMS,
        },
    },
];
